export function createPaymentChannelV3(send) {
  return (payeeId, body, ...args) =>
    send(
      {
        path: '/v3/payees/{payeeId}/paymentChannels/',
        pathParameters: { payeeId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
